import { EncoderDecoder } from '@iotize/common/converter/api';
import { isCodeError } from '@iotize/common/error';
import { Tap, TapError, TapResponseStatusError } from '@iotize/tap';
import { ResultCode } from '@iotize/tap/client/api';
import { TlvBundleConverter } from '@iotize/tap/client/impl';
import { VariableType } from '@iotize/tap/service/impl/variable';
import { TapDataError } from '../../tap-data-error';

import {
  AbstractBundleDataStream,
  EditableDataStreamInterface,
  KeyTypeType,
  RawBundleType,
} from '../../utility/editable-data-stream';
import {
  TapVariable,
  createTapVariableFromConfig,
} from '../tap-variable/tap-variable';

export const TLV_BUNDLE_CONVERTER = new TlvBundleConverter();

export interface TapBundleContextType {
  tap: Tap;
  config: TapBundle.Config;
}

export type TapVariableConfig<DataType> = {
  id: number;
  length?: number;
} & (
  | {
      dataType: VariableType.Data;
      converter?: EncoderDecoder<DataType, Uint8Array>;
    }
  | {
      dataType?: VariableType.Data;
      converter: EncoderDecoder<DataType, Uint8Array>;
    }
);

export interface TapBundleConfig<KeyType extends KeyTypeType> {
  id: number;
  variables: Record<KeyType, TapVariableConfig<any>>; // TODO fix typing
}

export function createTapBundleFromConfig<DataType>(
  tap: Tap,
  name: KeyTypeType,
  config: TapBundleConfig<keyof DataType>,
): TapBundle<DataType> {
  const variables = (
    Object.keys(config.variables) as (keyof DataType)[]
  ).reduce<Partial<BundleVariableMapType<DataType>>>((acc, key) => {
    const value = config.variables[key];
    acc[key] = createTapVariableFromConfig(tap.service.variable, key, value);
    return acc;
  }, {}) as BundleVariableMapType<DataType>;

  return new TapBundle(
    name,
    {
      tap,
      config: {
        id: config.id,
      },
    },
    variables,
  );
}

export type BundleVariableMapType<DataType> = Record<
  keyof DataType,
  EditableDataStreamInterface<
    DataType[keyof DataType],
    Uint8Array,
    keyof DataType
  >
>;

export namespace TapBundle {
  export interface Config {
    /**
     * Configured bundle id
     */
    id: number;
  }
}
export class TapBundle<DataType> extends AbstractBundleDataStream<DataType> {
  get id() {
    return this._id;
  }

  get bundleId() {
    return this.context.config.id;
  }

  constructor(
    private _id: KeyTypeType,
    private context: TapBundleContextType,
    _variables: BundleVariableMapType<DataType>,
    // converter: EncoderDecoder<DataType, Uint8Array>
  ) {
    super(_variables);
    // this.converter = TLV_BUNDLE_CONVERTER;
    // super(
    //     context,
    //     undefined,
    // );
  }

  // addConfiguredVariable<T>(name: string, options: {
  //     id: number;
  //     dataType: VariableType.Data,
  //     length?: number
  // }) {
  //     if (this.hasVariable(options.id)) {
  //         throw new Error(`Alredy has variable ${name}`);
  //     }
  //     // this.context.config.variables.push({
  //     //     name,
  //     //     id: options.id
  //     // });
  //     const variable = new ConfiguredVariableDataStream<DataType>(
  //         // config as VariableConfigWithName,
  //         {
  //             tap: this.context.tap,
  //             config: {
  //                 id: options.id,
  //                 name
  //             }
  //         },
  //         getConverterFromVariableType(
  //             options.dataType,
  //             options.length || 1
  //         ),
  //         // dataStream,
  //     );

  //     this._variables.push(variable);
  // }

  async readRawInner(): Promise<RawBundleType<DataType>> {
    try {
      const variableIdMapping = (
        await this.context.tap.service.bundle.getValues(this.bundleId)
      ).body(TLV_BUNDLE_CONVERTER);

      const streamIdMapping: any = {}; // Partial<RawBundleType<DataType>>

      // for (const tapVariableId of vara)
      for (const variable of this.variables) {
        if (variable instanceof TapVariable) {
          if (variable.variableId in variableIdMapping) {
            streamIdMapping[variable.id] =
              variableIdMapping[variable.variableId];
          } else {
            streamIdMapping[variable.id] = undefined;
            // if (!(variable.id in streamIdMapping)) {
            //     streamIdMapping[variable.id] = variableIdMapping[]
            // }
            // (streamIdMapping as any)[variable.id]
            // TODO un mapped ?
            // throw new Error(`${variable.id} is not mapped`)
          }
        }
      }
      return streamIdMapping as RawBundleType<DataType>;
    } catch (err) {
      if (
        isCodeError<TapResponseStatusError>(
          TapError.Code.ResponseStatusError,
          err,
        )
      ) {
        switch (err.response.status) {
          case ResultCode.NOT_FOUND:
            throw TapDataError.bundleNotConfigured(this.context.config, err);
        }
      }
      throw err;
    }
  }
}
